import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Modal, ModalBody } from 'reactstrap';
import { SPOT_MIN_REQ_PHOTOS } from '../../consts/spot.consts';
import RequestMorePhotos from '../../components/request-more-photos';
import { ImageHelper } from '../../classes/image-helper.class';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import PictureSet from '../../components/picture-set';
import SvgChevronLeft from 'src/assets/svg/SvgChevronLeft.svg';
import SvgChevronRight from 'src/assets/svg/SvgChevronRight.svg';
import SvgCross from 'src/assets/svg/SvgCross.svg';
import './desktop-photo-gallery.scss';

const DesktopPhotoGallery = ({
    photos,
    currentPhoto,
    isOpen,
    toggle,
    handleNext,
    handleBack,
    hostId,
    spotId,
    title,
    state,
    city,
    SSR,
    useStateSSR,
    useEffectSSR,
    userName,
    userIMG,
}) => {
    const useStateC = useStateSSR || useState;
    const useEffectC = useEffectSSR || useEffect;
    const [loading, setLoading] = useStateC(false);
    const photo = photos[currentPhoto];
    const altImg = title ? `${title} - ${city}, ${state}` : 'Spot thumbnail';
    const length = !userIMG && photos.length < SPOT_MIN_REQ_PHOTOS ? photos.length + 1 : photos.length;
    const showReq = !userIMG && photos.length < SPOT_MIN_REQ_PHOTOS && currentPhoto == photos.length;
    let submittedBy = '';

    if (!showReq && photo?.providedById !== null && photo?.providedBy && hostId !== photo?.providedBy.id) {
        const monthYear = moment(photo?.createdAt).format('MMM YYYY');
        submittedBy = `Submitted by: ${photo?.providedBy.firstname} ${photo?.providedBy.lastInitial}. - ${monthYear}`;
    }

    const pressHandler = ({ key }) => {
        if (key === 'ArrowRight') {
            handleNext();
        } else if (key === 'ArrowLeft') {
            handleBack();
        }
    };

    useEffectC(() => {
        if (currentPhoto > -1) {
            setLoading(true);
            setTimeout(() => setLoading(false), 20);
        }
    }, [currentPhoto]);

    useEffectC(() => {
        window.addEventListener('keydown', pressHandler);

        return () => {
            window.removeEventListener('keydown', pressHandler);
        };
    }, []);

    if (!showReq && !photo) {
        return '';
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            className={`desktop-photo-modal ${SSR ? 'desktop-photo-modal-ssr' : ''} ${userIMG ? 'review-photo-modal' : ''}`}
            backdropClassName="desktop-photo-backdrop"
        >
            <ModalBody className="photo-modal-body">
                <div className="photo-modal-back cursor-pointer" onClick={handleBack}>
                    <SvgChevronLeft />
                </div>
                <div className="photo-modal-item">
                    {showReq ? (
                        <>
                            <RequestMorePhotos id={spotId} />
                            <p className="spot-detail-photos-counter snif-s2 snif-medium mb-0">
                                <span className="photos-text">{`${currentPhoto + 1} of ${length}`}</span>
                            </p>
                        </>
                    ) : !loading ? (
                        <>
                            <PictureSet
                                imgs={ImageHelper.getUrlFromOptions(photo.imageAws, `fit-in/${IMG_RESIZES.x01600}`)}
                                className="photos-item"
                                alt={altImg}
                                SSR={SSR}
                                useState={useStateSSR}
                            />
                            {submittedBy && (
                                <div className="photos-submitted-box">
                                    <p className="spot-detail-photos-submitted mb-0">
                                        <span className="photos-text">{submittedBy}</span>
                                    </p>
                                </div>
                            )}
                            <p className="spot-detail-photos-counter snif-s2 snif-medium mb-0">
                                <span className="photos-text">{`${currentPhoto + 1} of ${length}`}</span>
                            </p>
                            {Boolean(userIMG) && (
                                <div className="photo-modal-guest">
                                    <PictureSet imgs={userIMG} width={24} height={24} alt="Guest avatar" />
                                    <p className="snif-p snif-medium">{userName}</p>
                                </div>
                            )}
                            <div className="photo-modal-close" onClick={toggle}>
                                <SvgCross />
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                </div>
                <div className="photo-modal-next cursor-pointer" onClick={handleNext}>
                    <SvgChevronRight />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default DesktopPhotoGallery;
